export const isWithinHours = ({
  availabilityEnabled,
  timezone,
  availableHours,
}: {
  availabilityEnabled: boolean;
  timezone: string;
  availableHours: any;
}) => {
  const weekdays = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ] as const;

  if (!availabilityEnabled || !timezone || !availableHours) {
    return true;
  }

  const now = Temporal.Now.zonedDateTimeISO(timezone);
  const weekday = weekdays[now.dayOfWeek % 7]; // Ensures Sunday = 0
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  const dayHours = availableHours[weekday];

  if (!dayHours || !dayHours.enabled) {
    return false;
  }

  //backwards compatibility for non-time block schema ({enabled, start, end}
  if ("start" in dayHours && "end" in dayHours) {
    const start = parseTime(dayHours.start, now, timezone);
    const end = parseTime(dayHours.end, now, timezone);
    return (
      Temporal.ZonedDateTime.compare(start, now) <= 0 &&
      Temporal.ZonedDateTime.compare(now, end) <= 0
    );
  }

  if (dayHours.timeBlocks) {
    // Handling WidgetHours format with timeBlocks
    return dayHours.timeBlocks.some(
      ({ start, end }: { start: string; end: string }) => {
        if (!start || !end) {
          return false;
        }
        const blockStart = parseTime(start, now, timezone);
        const blockEnd = parseTime(end, now, timezone);
        return (
          Temporal.ZonedDateTime.compare(blockStart, now) <= 0 &&
          Temporal.ZonedDateTime.compare(now, blockEnd) <= 0
        );
      },
    );
  }

  return false;
};

export const parseTime = (
  time: string,
  now: Temporal.ZonedDateTime,
  timezone: string,
) => {
  const [hour, minute] = time.split(":").map(Number);

  // Validate hour and minute are finite numbers
  if (!Number.isFinite(hour) || !Number.isFinite(minute)) {
    throw new Error(`Invalid time format: ${time}`);
  }

  // Validate hour is in valid range (0-23)
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  if (hour < 0 || hour > 23) {
    throw new Error(`Invalid hour value: ${hour}`);
  }

  // Validate minute is in valid range (0-59)
  // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
  if (minute < 0 || minute > 59) {
    throw new Error(`Invalid minute value: ${minute}`);
  }

  return Temporal.ZonedDateTime.from({
    timeZone: timezone,
    year: now.year,
    month: now.month,
    day: now.day,
    hour,
    minute,
  });
};
